module.exports = __webpack_public_path__ + "static/media/hilary-duff.dbc80448.jpg";